/* eslint-disable no-empty */
const FORM_BLOCK = '.form-block';
const FORM_GROUP = '.form-group';
const IS_ERROR = 'is--error';

let current = 1;
let maxFields;

export function setMainErrorMessage(text) {
    $('.checkout-error__text').text(text);
    let $errorMsg = $('.checkout-error__msg');
    $('.checkout-v2 .checkout-error__msg .mod-error__body').removeClass('d-none');
    if($errorMsg.hasClass('d-none')) {
        $errorMsg.removeClass('d-none');
    }
    $('html, body').animate({ scrollTop: '0' });
}

export function checkoutPrev() {
    let $this = $(this);
    var previousUrl = $this.data('previousurl');
    if(previousUrl) {
        window.location.href = previousUrl;
    }
}

export function hideMainErrorMessage() {
    $('.checkout-error__msg').addClass('d-none');
    $('.checkout-error__text').text('');
}

export function hideMainPaymentErrorMessage() {
    $('.checkout-error__message').addClass('d-none');
}

export function moveToNextCheckoutStep(result) {
    let $nextBtn = $('.checkout-next');
    var nextUrl = $nextBtn.data('nexturl');
    if(result && result.RedirectPageUrl) {
        nextUrl = result.RedirectPageUrl;
    }
    if(nextUrl) {
        window.location.href = nextUrl;
    }
}

export function isPaymentManageAutoship() {
    let isManageAutoship = $('#isManageAutoship').val();
    return isManageAutoship && isManageAutoship.toLowerCase() === 'true' && $('form#payment').length > 0;
}

export function paymentFormDirty() {
    if(!isPaymentManageAutoship()) return;
    let $nextBtn = $('.checkout-next');
    $nextBtn.text($nextBtn.data('savetext'));
    $('#paymentChanged').val('true');
}

export function removeAddress(e) {
    e.preventDefault();
    let $this = $(this);
    paymentFormDirty();
    let $addAddress = $('#addAddress');
    let $loadAddress = $(`#loadAddress${current}`);
    $loadAddress.val('');
    if(current === maxFields) {
        let previousField = maxFields - 1;
        $(`#remove${previousField}`).show();
    }
    current--;
    $this.parents(FORM_BLOCK).remove();
    $addAddress.show();
}

export function addAddress(e) {
    e.preventDefault();
    let $this = $(this);
    let $address1 = $('#address1Input');
    let availableaddresslines = $this.data('availableaddresslines');
    if(availableaddresslines) { maxFields = availableaddresslines.split(',').length; }
    let invalidmsg = '';
    if($address1.data('msg-invalidchars')) {
        invalidmsg = $address1.data('msg-invalidchars');
    }

    let newAddressLineHelpText = '';
    if($address1.data('msg-addfieldhelptext')) {
        newAddressLineHelpText = $address1.data('msg-addfieldhelptext');

        // overrides the std jquery validate msg with our own
        if(invalidmsg !== '') {
            $.validator.messages.maxlength = invalidmsg;
        }
    }

    let newAddressLineMaxLength = '50';
    if($address1.data('addfieldmaxlength')) {
        newAddressLineMaxLength = $address1.data('addfieldmaxlength');
    }

    if(current < maxFields) {
        current++;
        let $addressCurrent = $(`#address${current}label`);
        let addressLineLabel = `Address Line ${current}`;

        if($addressCurrent && $addressCurrent.length > 0) {
            addressLineLabel = $addressCurrent.val();
        }

        let addressField = `<div class="form-block"><label for="address${current}Input" class="form-label" >${addressLineLabel}</label>
        <input id="address${current}Input" name="address${current}Input" maxlength="${newAddressLineMaxLength}" class="form-input" type="text" data-msg-required="${$address1.attr('data-msg-required')}"
        data-invalidchars="${$address1.data('invalidchars')}" data-msg-invalidchars="${invalidmsg}" required="false">${newAddressLineHelpText}
        <button id="remove${current}" type="button" class="form-group__btn form-group__btn--remove btn btn-link">Remove</button></div>`;

        $this.parent(FORM_GROUP).append(addressField);
        $(`#address${current}Input`).on('blur', paymentFormDirty);

        $(`#remove${current}`).on('click', removeAddress);
    } if(current === maxFields) {
        let previousField = maxFields - 1;
        $this.hide();
        $(`#remove${previousField}`).hide();
    }
    updateFormAddressValidator();
}

export function focusOnAnyErrors() {
    const $modError = $('.mod-field--error, .mod-checkbox--error').first();
    if($modError.length) {
        $('html, body').animate({ scrollTop: $modError.offset().top - 90 });
        $modError.find('input, select').first().focus();
        return;
    }
    $('.form-block').each(function() {
        let $this = $(this);
        if($this.hasClass(IS_ERROR)) {
            let error = $this.offset().top;
            $('html, body').animate({ scrollTop: error - 90 });
            $this.first().find('input').focus();
            return false;
        }
    });
}

export function focusOnAnyErrorsOnPage() {
    let $error = $('.checkout-error__msg');
    if($error.length && !$error.hasClass('d-none')) {
        let errorMessage = $error.offset().top;
        $('html, body').animate({ scrollTop: errorMessage - 90 });
        $error.focus();
        return false;
    }
}

export function loadAddress() {
    let $address2 = $('#loadAddress2');
    let $address3 = $('#loadAddress3');
    let address3;
    if($address3.length > 0) {
        address3 = $address3.val();
    }
    if($address2.length > 0) {
        let address2 = $address2.val();
        if(!!address2 || !!address3) {//eslint-disable-line
            $('#addAddress').triggerHandler('click');
            let $address2Field = $('#address2Input');
            $address2Field.val(address2).trigger('input');
        }
    }

    if (!!address3) {//eslint-disable-line
        $('#addAddress').triggerHandler('click');
        let $address3Field = $('#address3Input');
        $address3Field.val(address3).trigger('input');
    }
}

export function getToastMessage(result) {
    if(result && result.Messages) {
        let toastMsg = result.Messages.find(x => x.IsToast === true);
        if(toastMsg) return toastMsg.MessageText;
        return '';
    }
    return '';
}

export function removeCoupon() {
    let $this = $(this);
    let couponCode = $this.parent().data('coupon');
    let coupon = $this.parent().closest('span');

    coupon.remove();

    let applyCouponBtns = $('.applyCouponButton');
    if(applyCouponBtns.length) {
        let applyCouponBtn = applyCouponBtns.filter(function() { return this.value === couponCode; });
        if(applyCouponBtn.length) {
            let applyText = applyCouponBtn.data('apply-text');
            applyCouponBtn.text(applyText);
            applyCouponBtn.removeClass('button-apply--applied');
            $(`.coupon_${couponCode}`).removeClass('list-card--applied');
        }
    }
}

const FOCUSABLE_SELECTORS = 'a[href], button:not([disabled]), textarea, input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

function trapFocus(e, modalEl) {
    let focusableElements = Array.from(modalEl.querySelectorAll(FOCUSABLE_SELECTORS));
    if(focusableElements.length === 0) return;
    let firstFocusable = focusableElements[0];
    let lastFocusable = focusableElements[focusableElements.length - 1];
    if(e.shiftKey) {
        if(document.activeElement === firstFocusable) {
            e.preventDefault();
            lastFocusable.focus();
        }
    } else {
        if(document.activeElement === lastFocusable) {
            e.preventDefault();
            firstFocusable.focus();
        }
    }
}

function getFirstFocusable(modalEl) {
    return modalEl.querySelector(FOCUSABLE_SELECTORS);
}

function setBackgroundAriaHidden(hidden) {
    let $modal = $('#couponsModal');
    if(!$modal.length) return;
    let $modalBodyChild = $modal.parentsUntil('body').last();
    $('body').children().not($modalBodyChild).each(function() {
        let $el = $(this);
        if(hidden) {
            $el.data('aria-hidden-prev', $el.attr('aria-hidden'));
            $el.attr('aria-hidden', 'true');
        } else {
            let prev = $el.data('aria-hidden-prev');
            $el.removeData('aria-hidden-prev');
            if(prev === undefined) {
                $el.removeAttr('aria-hidden');
            } else {
                $el.attr('aria-hidden', prev);
            }
        }
    });
}

export function checkCouponsModal(parentSelector) {
    let $couponsModal = $('#couponsModal');
    if($couponsModal.length > 0) {
        let $parent = $(parentSelector);
        $parent.find('.badge svg').on('click', removeCoupon);
        $parent.find('[data-dismiss-modal="coupon-modal"]').on('click', closeModal);
        $parent.find('.cart-coupon-details-button,.details-button').on('click', toggleDetails);

        // Keyboard: Escape closes, Tab is trapped inside the modal
        $couponsModal.off('keydown.couponModal').on('keydown.couponModal', function(e) {
            if(e.key === 'Escape') {
                closeModal();
                return;
            }
            if(e.key === 'Tab') {
                trapFocus(e, $couponsModal[0]);
            }
        });

        // When modal fully appears: hide background from AT and move focus inside
        $couponsModal.off('shown.bs.modal.couponModal').on('shown.bs.modal.couponModal', function() {
            setBackgroundAriaHidden(true);
            let firstFocusable = getFirstFocusable($couponsModal[0]);
            if(firstFocusable) {
                firstFocusable.focus();
            } else {
                $couponsModal[0].focus();
            }
        });

        // When modal fully closes: restore background visibility and return focus to trigger
        $couponsModal.off('hidden.bs.modal.couponModal').on('hidden.bs.modal.couponModal', function() {
            setBackgroundAriaHidden(false);
            let trigger = $couponsModal.data('modal-trigger');
            if(trigger) {
                trigger.focus();
                $couponsModal.removeData('modal-trigger');
            }
        });

        let $couponsExpiration = $parent.find('.coupon-expiration-date');
        if($couponsExpiration.length > 0) {
            Array.prototype.forEach.call($couponsExpiration, function (date) {
                const utcDate = new Date($(date).data('expdate'));
                let formatOptions = { year: 'numeric', month: 'short', day: '2-digit', hour: 'numeric', minute: '2-digit', hourCycle: 'h12'};
                let cultureName = $couponsModal.data('culture-name') || 'en-US';
                let dateParts = new Intl.DateTimeFormat(cultureName, formatOptions).formatToParts(utcDate);
                let currentMarket = $couponsModal.data('current-market') || [];
                let datePartObj = getDatePartObj(dateParts);
                let formattedDate = `${datePartObj.month.toUpperCase()}-${datePartObj.day}-${datePartObj.year}`;
                let formattedTime = `${datePartObj.hour}:${datePartObj.minute} ${datePartObj.dayPeriod.toUpperCase()}`;
                if(currentMarket === 'CA') {
                    formattedDate = `${datePartObj.day}-${datePartObj.month.toUpperCase()}-${datePartObj.year}`;
                }
                var formattedDateTime = `${formattedDate} ${formattedTime}`;
                date.textContent = formattedDateTime;
            });
        }
    }
}

export function updateAnchorsToCultureCode(currentCultureCode, newCultureCode) {
    const $allAnchors = $('a');
    if($allAnchors.length > 0) {
        const currentUrlFragment = `/${currentCultureCode}/`;
        const newUrlFragment = `/${newCultureCode}/`;
        const anchorRegex = new RegExp(currentUrlFragment, 'i');
        $.each($allAnchors, function (idx, anchor) {
            const $anchor = $(anchor);
            const hrefValue = $anchor.prop('href');
            const matches = hrefValue.match(anchorRegex);
            if(!matches || matches.length === 0) return;
            const newHref = hrefValue.replace(anchorRegex, newUrlFragment);
            $anchor.prop('href', newHref);
        });
    }
}

function updateFormAddressValidator() {
    let $form = $('form#shipping');
    if($form.length === 0) {
        $form = $('form#enrollment');
    }
    if($form.length > 0) {
        let invalidCharsMsg = $form.data('msg-invalidchars');
        configureAddressFieldInvalidCharsValidator(invalidCharsMsg);
    }
}

export function configureAddressFieldInvalidCharsValidator(msg) {
    $.validator.addMethod('checkAddressFieldInvalidChars', function (value, element) {
        let invalidChars = $(element).data('invalidchars');
        if(!invalidChars) return true;
        let invalidCharsRegex = new RegExp(invalidChars, 'g');
        let result = invalidCharsRegex.test(value);
        return this.optional(element) || !result;
    }, function (params, element) {
        let specificMsg = $(element).data('msg-invalidchars');
        return specificMsg || msg;
    });
}

export function isRequiredField(validator, element) {
    let requiredFlag = false;
    let requiredExpression = validator.settings.rules[element.id].required;
    if(!requiredExpression) return requiredFlag;
    if(typeof requiredExpression === 'boolean') requiredFlag = requiredExpression;
    if(typeof requiredExpression === 'string') {
        requiredFlag = $(requiredExpression).length > 0;
    }
    return requiredFlag;
}

function getDatePartObj(datePartsArray) {
    let datePartsObj = {};
    if(datePartsArray && datePartsArray.length > 0) {
        datePartsArray.forEach(function(item) {
            datePartsObj[item.type] = item.value;
        });
    }
    return datePartsObj;
}

function closeModal() {
    let $couponModal = $('.cart-coupon__modal');
    $couponModal.modal('hide');
    let $errorMsg = $('.apply_coupon_failed');
    $errorMsg.hide();
    $errorMsg.text('');
}

function toggleDetails() {
    let $this = $(this);
    let $content = $this.next();
    $content.slideToggle('fast');
    $this.toggleClass('open');
}

function initEventHandlers() {
    $('.checkout-error__btn').on('click', hideMainErrorMessage);
    $('.checkout-error__button').on('click', hideMainPaymentErrorMessage);
    $('.checkout-v2 .checkout-error__msg:not(.d-none) .mod-error__body').removeClass('d-none');
    let $dataToggleTooltip = $('[data-toggle="tooltip"]');
    if($dataToggleTooltip.length) {
        $dataToggleTooltip.tooltip();
    }
    if($('#bpc-toggle-switch-button').length) {
        toggleContactBP($('#bpc-toggle-switch-button'), $('#ContactBrandPartner'));
    }
    if($('#es-toggle-switch-button').length) {
        toggleContactBP($('#es-toggle-switch-button'), $('#ContactEnrollingSponsor'));
    }
}

function toggleContactBP($switch, $hiddenInput) {
    if(!$switch.length || !$hiddenInput.length) {
        return;
    }

    // Modernized layout: $switch is a <label> wrapping a real checkbox (.mod-checkbox__input).
    const $modCheckbox = $switch.find('.mod-checkbox__input');
    if($modCheckbox.length) {
        $hiddenInput.val($modCheckbox.is(':checked') ? 'on' : 'off');
        $modCheckbox.on('change', function () {
            $hiddenInput.val(this.checked ? 'on' : 'off');
        });
        return;
    }

    // Legacy layout: slider spans toggle a `hideSwitch` class to represent on/off state.
    const $onSlider = $switch.find('.toggle-checkbox-on');
    const $offSlider = $switch.find('.toggle-checkbox-off');
    if($onSlider.length && $offSlider.length) {
        if($offSlider.hasClass('hideSwitch')) {
            $hiddenInput.val('on');
        } else {
            $hiddenInput.val('off');
        }
        $switch.on('click', function () {
            $onSlider.toggleClass('hideSwitch');
            $offSlider.toggleClass('hideSwitch');

            const isOn = !$onSlider.hasClass('hideSwitch');
            $hiddenInput.val(isOn ? 'on' : 'off');
        });
    }
}

$(function () {
    initEventHandlers();
});
